import React, { useState, useEffect } from "react";
import {  Send } from "@material-ui/icons";
import { useContactsState } from "../../../contexts";
import * as S from "./styles";
import { CircularProgress } from "@material-ui/core";
import { API } from "shared/services";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { getBase64 } from "modules/app/utils";

export function PasteImageModal({imgSrc, handleCloseModal, blob}) {
  const [loading, setLoading] = useState();
  const [replySources, setReplySources] = useState();
  const { currentContact } = useContactsState();
  const { t } = useTranslation();


  async function handleSubmit(){
    setLoading(true);
    try {

      const imageBase64 = await getBase64(blob);
      const imageName = blob.name;



      await API.post(`/customers/${currentContact.id}/messages`, {
        message: {
          body: imageName,
          file: {
            data: imageBase64,
            filename: imageName,
          },
        },
        reply_sources: replySources,
      });

      toast.success(
        `Imagem enviada com sucesso.`
      );
      setLoading(false);
    } catch (e) {
      toast.error(`Erro, a imagem não foi enviada. Tente novamente.`);
      setLoading(false);
    }

    handleCloseModal();

  }

  useEffect(() => {
    if (currentContact?.reply_sources) {
      setReplySources(currentContact.reply_sources);
    }
  }, [currentContact]);

  return (
    <S.PasteImgModalOverlay key={imgSrc}>
            <S.PasteImgModalContainer>
              <S.HeaderModal>
                  <S.TitleModal>{t("Chat:pasteImageModal.title")}</S.TitleModal>
                  <S.IconBtn
                    aria-label="display more actions"
                    edge="end"
                    color="inherit"
                    onClick={()=> handleCloseModal()}
                    >
                    <S.CloseModal/>
                  </S.IconBtn>
              </S.HeaderModal>
              <S.ImageContent src={imgSrc} key={imgSrc} alt={`Pasted: ${imgSrc}`} />
              <S.SendBtn
              color="primary"
              variant="contained"
              component="label"
              onClick={handleSubmit}
              startIcon={loading ? <CircularProgress /> : <Send />}
            >
              {t("Chat:pasteImageModal.send")}
            </S.SendBtn>
            </S.PasteImgModalContainer>
          </S.PasteImgModalOverlay>
  );
}
